import { friendlyErrorMessage } from '@/core/lib/dbError'
import { assertWriteIdentity, captureWriteIdentity, type WriteIdentity } from '@/core/api/http'
import { generateDocument } from '@/core/api/documents'
import { ok, technical, type Result } from '@/core/lib/result'
import type { Organisation } from '@/core/data/organisation'

function joinAnschrift(
  strasse?: string | null,
  hausnummer?: string | null,
  plz?: string | null,
  ort?: string | null,
): string {
  const street = [strasse, hausnummer].filter(Boolean).join(' ').trim()
  const city = [plz, ort].filter(Boolean).join(' ').trim()
  return [street, city].filter(Boolean).join(', ')
}

export function buildDurchfuehrungsort(
  org: Organisation | null,
): string {
  return joinAnschrift(
    org?.durchf_strasse,
    org?.durchf_hausnummer,
    org?.durchf_plz,
    org?.durchf_ort,
  )
}

export async function fillTb(coachingId: string, identity: WriteIdentity = captureWriteIdentity()): Promise<Result<void>> {
  try {
    await generateDocument('tb', { coaching_id: coachingId }, identity)
    assertWriteIdentity(identity)
    return ok(undefined)
  } catch (error) {
    assertWriteIdentity(identity)
    return technical(friendlyErrorMessage(error, 'Trägerbestätigung konnte nicht erstellt werden.'))
  }
}
